import React from "react";
import { useNavigate } from "react-router-dom";
import { Calculator, ArrowRight } from "lucide-react";
import { COLORS } from "../../utils/constants";

export const SimulateurShortcut = () => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate("/simulateur")}
      data-testid="dashboard-simulateur-shortcut"
      className="w-full rounded-xl border p-4 flex items-center gap-3 text-left hover:shadow-md transition-shadow"
      style={{ backgroundColor: COLORS.bg, borderColor: COLORS.accent + "55" }}
    >
      <span className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: COLORS.accent, color: "white" }}>
        <Calculator size={20} />
      </span>
      <span className="flex-1">
        <span className="block font-semibold" style={{ color: COLORS.text }}>Un contrat en vue ? Simule-le</span>
        <span className="block text-xs text-muted-foreground">Ce qu'il te rapporte vraiment, et son effet sur tes seuils, ta retraite et ta CFE.</span>
      </span>
      <ArrowRight size={18} style={{ color: COLORS.accent }} />
    </button>
  );
};

export default SimulateurShortcut;
